import Button from '@mui/material-next/Button';
import DescriptionIcon from '@mui/icons-material/Description';

export default function BotaoCertidoes () {
    return (
        <Button variant="text" sx={{ fontFamily: 'sans-serif', color: 'green' }} href="https://www.cnm.org.br/institucional/transparencia?categoria=certidoes-cnm" target="_blank"> 
            <DescriptionIcon/> Certidões
        </Button>
    )
}